import { render, staticRenderFns } from "./KoMixedGamePublic.vue?vue&type=template&id=6c06b046&scoped=true&"
import script from "./KoMixedGamePublic.vue?vue&type=script&lang=js&"
export * from "./KoMixedGamePublic.vue?vue&type=script&lang=js&"
import style0 from "./KoMixedGamePublic.vue?vue&type=style&index=0&id=6c06b046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c06b046",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
